import styled from 'styled-components';
import { Img } from '../../../components/common/Image';
import Logo from '../../../assets/media/aden/aden-red.png';

const GuestNavbar = () => {
    const isMobile = window.innerWidth < 768;

    return (
        <NavbarWrapper>
            <LogoWrapper>
                {isMobile ? (
                    <Img w="auto" h="24px" src={Logo} />
                ) : (
                    <Img w="auto" h="40px" src={Logo} />
                )}
                <h2>Invitado</h2>
            </LogoWrapper>
        </NavbarWrapper>
    );
};

export default GuestNavbar;

const NavbarWrapper = styled.div`
    width: calc(100% - 10rem);
    padding: 0 5rem;
    height: 64px;
    box-shadow: 0px 5px 20px 0px #0000000f;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;

    @media (width < 580px) {
        width: calc(100% - 2rem);
        padding: 0 1rem;
    }
`;

const LogoWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;

    h2 {
        font-size: 18px;
        color: #b31d15;
    }

    @media (max-width: 650px) {
        img {
            height: 50px;
        }
    }

    @media (max-width: 420px) {
        img {
            height: 60px;
        }
    }

    @media (max-width: 380px) {
        img {
            height: 50px;
        }
    }
`;
